import * as moment from 'moment';
import {Observable, ReplaySubject} from 'rxjs';
import {combineLatest} from 'rxjs/observable/combineLatest';
import {checkThat} from '../../../../../common/typescript/preconditions.util';
import Moment = moment.Moment;
import assign = require('core-js/fn/object/assign');
/**
 * Created by Rodrigo Quesada on 13/01/17.
 */

//region Other Classes
class DateChange {
    constructor(readonly value: Moment | undefined, readonly selected: boolean = false) {}
}
//endregion

export interface MonthSelectorComponentModelData {
    date?: Moment;
    minDate: Moment;
    maxDate: Moment;
}

export class MonthSelectorComponentModel implements MonthSelectorComponentModelData {

    minDate$ = new ReplaySubject<Moment>(1);

    set minDate(value: Moment) { this.minDate$.next(value.clone().startOf('month')); }

    maxDate$ = new ReplaySubject<Moment>(1);

    set maxDate(value: Moment) { this.maxDate$.next(value.clone().startOf('month')); }

    private readonly _dateChangeSubject = new ReplaySubject<DateChange>(1);

    readonly date$: Observable<DateChange> = combineLatest(this._dateChangeSubject, this.minDate$, this.maxDate$)
        .map(([dateChange, minDate, maxDate]) => {
            return new DateChange(
                dateChange.value ? moment.min(moment.max(dateChange.value, minDate), maxDate).clone() : undefined,
                dateChange.selected
            );
        });

    set date(value: Moment | undefined) { this._changeDate(value, false); }

    set dateSelection(value: Moment | undefined) { this._changeDate(value, true); }

    private _changeDate(value: Moment | undefined, selected: boolean) {
        this._dateChangeSubject.next(new DateChange(value ? value.clone().startOf('month') : undefined, selected));
    }

    constructor(data: MonthSelectorComponentModelData) {
        assign(this, data);

        this._checkConstraints();
    }

    private _checkConstraints() {
        combineLatest(this.minDate$, this.maxDate$)
            .subscribe(([min, max]) => checkThat(min.isSameOrBefore(max), () => 'minDate must be less than or equal to maxDate'));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/controls/monthpicker/selector/month-selector-model.class.ts